<template>
  <BaseModal :modal-title="title" ref="modal" @close="handleClose" :footerPosition="footerPosition">
    {{ message }}
    <template #footer>
      <template v-for="(button, index) in buttons" :key="index">
        <button type="button" class="btn" :class="[button.class || 'btn-label-secondary', button.customClass]"
          @click="handleButtonClick(button.value)" :disabled="button.disabled" :style="button.style">
          {{ button.text }}
        </button>
      </template>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/Modal.vue'

export default {
  name: 'ConfirmModal',
  components: {
    BaseModal
  },
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    footerPosition: {
      type: String,
      default: 'center',
      validator: (value) => ['start', 'center', 'end', 'between'].includes(value)
    },
    buttons: {
      type: Array,
      default: () => [
        {
          text: 'Отмена',
          value: false,
          class: 'btn-label-secondary'
        },
        {
          text: 'Подтвердить',
          value: true,
          class: 'btn-primary'
        }
      ]
    }
  },
  data() {
    return {
      promiseResolve: null
    }
  },
  methods: {
    handleClose() {
      this.handleButtonClick(false)
    },
    handleButtonClick(value) {
      if (this.promiseResolve) {
        this.promiseResolve(value)
        this.promiseResolve = null
        this.$refs.modal.closeModal()
      }
    },
    handleEnterPress(event) {
      const confirmButton = this.buttons.find(btn => btn.class === 'btn-primary')
      if (confirmButton && !confirmButton.disabled) {
        event.preventDefault()
        this.handleButtonClick(confirmButton.value)
      }
    },
    getAnswer() {
      this.$refs.modal.openModal()
      return new Promise((resolve) => {
        this.promiseResolve = resolve
      })
    }
  }
}
</script>